import { render } from "./Profile.vue?vue&type=template&id=1965ad5c"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=1965ad5c&lang=css"

import exportComponent from "/Users/yenneelim/Development/signon_static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__